/**
 * shop-filter-drawer.js — bộ lọc Cửa hàng dạng drawer trượt từ dưới lên trên mobile (mục 18).
 *
 * Markup cần:
 *   button[data-filter-open][aria-controls="shop-filters"][aria-expanded]  (nút "Bộ lọc (3)")
 *   aside.filter-drawer#shop-filters[data-filters]
 *     > .filter-drawer__overlay[data-filter-close]
 *     > form[data-filter-form] > … h2.filter-panel__title[id] … button.filter-panel__close[data-filter-close]
 *
 * Dưới 1024px CSS đã biến sidebar thành drawer (components/_filter.scss); file này chỉ lo
 * hành vi của một hộp thoại: mở / đóng, khoá cuộn nền (body.u-no-scroll), focus vào nút
 * đóng, Tab vòng trong drawer, Esc / bấm overlay để đóng, trả focus về nút "Bộ lọc".
 * role="dialog" chỉ gắn lúc mở — trên desktop cùng phần tử đó là sidebar bình thường.
 *
 * Bấm "Xem N kết quả" (submit): filters.js đã lọc xong (listener đăng ký trước), ở đây
 * đóng drawer rồi cuộn về đầu danh sách nếu nó đang khuất.
 *
 * WP: giữ nguyên file này — lọc chuyển sang server nhưng drawer vẫn là việc của giao diện.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DESKTOP_QUERY = '(min-width: 1024px)';
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function all(selector, scope) {
        return [].slice.call((scope || document).querySelectorAll(selector));
    }

    function isShown(el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
    }

    function init() {
        var root = document.querySelector('[data-filters]');
        var form = root ? root.querySelector('[data-filter-form]') : null;
        if (!form) return;

        var openers = all('[data-filter-open]');
        var title = root.querySelector('.filter-panel__title');
        var results = document.querySelector('[data-filter-results]');
        var mq = window.matchMedia(DESKTOP_QUERY);
        var lastFocus = null;

        function isOpen() {
            return root.classList.contains('is-open');
        }

        function open() {
            if (mq.matches || isOpen()) return;
            lastFocus = document.activeElement;
            root.classList.add('is-open');
            root.setAttribute('role', 'dialog');
            root.setAttribute('aria-modal', 'true');
            if (title && title.id) root.setAttribute('aria-labelledby', title.id);
            document.body.classList.add('u-no-scroll');
            openers.forEach(function (button) {
                button.setAttribute('aria-expanded', 'true');
            });
            // .is-open đổi visibility ngay (transition-delay 0) nên focus được luôn
            var close = root.querySelector('.filter-panel__close');
            if (close) close.focus();
        }

        function close(restore) {
            if (!isOpen()) return;
            root.classList.remove('is-open');
            root.removeAttribute('role');
            root.removeAttribute('aria-modal');
            root.removeAttribute('aria-labelledby');
            document.body.classList.remove('u-no-scroll');
            openers.forEach(function (button) {
                button.setAttribute('aria-expanded', 'false');
            });
            if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
            lastFocus = null;
        }

        // Chỉ cuộn khi đầu danh sách đang khuất — đứng sẵn ở đó thì đừng làm trang giật
        function revealResults() {
            if (!results) return;
            var top = results.getBoundingClientRect().top;
            if (top < 0 || top > window.innerHeight * 0.5) results.scrollIntoView({ block: 'start' });
        }

        openers.forEach(function (button) {
            button.addEventListener('click', open);
        });

        all('[data-filter-close]', root).forEach(function (el) {
            el.addEventListener('click', function () {
                close();
            });
        });

        form.addEventListener('submit', function () {
            close();
            revealResults();
        });

        // Esc đóng; Tab / Shift+Tab vòng trong form khi drawer là hộp thoại modal
        document.addEventListener('keydown', function (event) {
            if (!isOpen()) return;
            if (event.key === 'Escape' || event.key === 'Esc') {
                close();
                return;
            }
            if (event.key !== 'Tab') return;
            var items = all(FOCUSABLE, form).filter(isShown);
            if (!items.length) return;
            var first = items[0];
            var last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });

        // Xoay ngang / kéo cửa sổ sang desktop khi drawer đang mở: gỡ khoá cuộn
        function onMedia() {
            if (mq.matches) close(false);
        }
        if (mq.addEventListener) mq.addEventListener('change', onMedia);
        else if (mq.addListener) mq.addListener(onMedia);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
